import { useEffect } from "react";
import "./App.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import SearchNav from "./FunctionComponents/Searchnav";
import Footer from "./FunctionComponents/Footer";
import { PageLayout } from "./FunctionComponents/PageLayout";
import Home from "../src/Pages/Home";
import Metrics from "../src/Pages/Metrics";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { loginRequest } from "./authConfig";
import QueriesAnswer from "./FunctionComponents/QueriesAnswer/QueriesAnswer";
import AnalyticsPage from "./FunctionComponents/AnalyticsPage";
import HallofFamePage from "./Pages/HallofFamePage";
import Dashboard from "../src/Pages/Dashboard";
import Reviews from "./FunctionComponents/Reviews";
import ProtectedRoute from "./FunctionComponents/ProtectedRoute";
import UserMaintenance from "./Pages/UserMaintenance";
import { useDispatch, useSelector } from "react-redux";
import { selectAdminIds } from "./store/UserMaintanence";
import { getUserMaintanenceData } from "./store/UserMaintanence";
function App({ pca }) {
  return (
    <MsalWrapper pca={pca} />
  );
}

function MsalWrapper({ pca }) {
  const navigate = useNavigate();

  const navigationClient = new CustomNavigationClient({
    navigate: (path) => navigate(path),
  });

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <Pages />
      </PageLayout>
    </MsalProvider>
  );
}

function Pages() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount) {
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  }

  useEffect(() => {
    if (activeAccount) {
      fetchAccessToken();
    }
  }, [activeAccount]);

  const adminEnterpriseIds = useSelector(selectAdminIds);
  const isAdmin = adminEnterpriseIds?.includes(loggedInEnterpriseId);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserMaintanenceData());
  }, []);

  const fetchAccessToken = async () => {
    if (!activeAccount) return;

    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });

      const bearer = `Bearer ${response.accessToken}`;
      localStorage.setItem("token", bearer);
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };

  return (
    <>
      <SearchNav />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route
          path="/metrics"
          element={
            <ProtectedRoute isAllowed={isAdmin}>
              <Metrics />
            </ProtectedRoute>
          }
        />
        <Route path="/queries/:id" element={<QueriesAnswer/>} />
        <Route path="/hall-of-fame" element={<HallofFamePage/>} />
        <Route path="/dashboard" element={<Dashboard/>} />
        <Route
          path="/reviews"
          element={
            <ProtectedRoute isAllowed={isAdmin}>
              <Reviews />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute isAllowed={isAdmin}>
              <AnalyticsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-maintenance"
          element={
            <ProtectedRoute isAllowed={isAdmin}>
              <UserMaintenance />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
